module.exports = __webpack_public_path__ + "img/colour.f478193d.png";